// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-en-js": require("gatsby-module-loader?name=component---src-pages-index-en-js!/Users/fabianbrenes/squidsource/src/pages/index.en.js"),
  "component---src-pages-index-es-js": require("gatsby-module-loader?name=component---src-pages-index-es-js!/Users/fabianbrenes/squidsource/src/pages/index.es.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/Users/fabianbrenes/squidsource/src/pages/index.js"),
  "component---src-pages-portfolio-item-js": require("gatsby-module-loader?name=component---src-pages-portfolio-item-js!/Users/fabianbrenes/squidsource/src/pages/portfolio-item.js")
}

exports.json = {
  "layout-en.json": require("gatsby-module-loader?name=path---!/Users/fabianbrenes/squidsource/.cache/json/layout-en.json"),
  "en.json": require("gatsby-module-loader?name=path---en!/Users/fabianbrenes/squidsource/.cache/json/en.json"),
  "layout-es.json": require("gatsby-module-loader?name=path---!/Users/fabianbrenes/squidsource/.cache/json/layout-es.json"),
  "es.json": require("gatsby-module-loader?name=path---es!/Users/fabianbrenes/squidsource/.cache/json/es.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/Users/fabianbrenes/squidsource/.cache/json/index.json"),
  "layout-portfolio-item.json": require("gatsby-module-loader?name=path---!/Users/fabianbrenes/squidsource/.cache/json/layout-portfolio-item.json"),
  "portfolio-item.json": require("gatsby-module-loader?name=path---portfolio-item!/Users/fabianbrenes/squidsource/.cache/json/portfolio-item.json")
}

exports.layouts = {
  "layout---en": require("gatsby-module-loader?name=component---src-layouts-en-js!/Users/fabianbrenes/squidsource/.cache/layouts/en.js"),
  "layout---es": require("gatsby-module-loader?name=component---src-layouts-es-js!/Users/fabianbrenes/squidsource/.cache/layouts/es.js"),
  "layout---portfolio-item": require("gatsby-module-loader?name=component---src-layouts-portfolio-item-js!/Users/fabianbrenes/squidsource/.cache/layouts/portfolio-item.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js